// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3C6sV","content":"styles_content__1B8Ju","selectAll":"styles_selectAll__1AN9m"};